module.exports = __webpack_public_path__ + "static/media/Report.f102b6d0.svg";